import type { IPreviewRow } from '@feathr/blackbox';

export const SAMPLE_DISPLAY_LENGTH = 60;
export const SAMPLE_TITLE_LENGTH = 200;

/*
 * Maps each saved column name to the first non-empty value in that column of
 * the preview's input rows. A column with no value maps to an empty string.
 * Input rows are keyed by the import's saved column names, so a headerless
 * file is keyed `Column 1` to `Column N`.
 */
export function getSampleValues(
  rows: IPreviewRow[],
  columnNames: string[],
): Record<string, string> {
  return Object.fromEntries(
    columnNames.map((columnName) => {
      const key = String(columnName);
      const sample = rows
        .map((row) => toCellText(row.input?.[key] as unknown))
        .find((text) => text.trim() !== '');
      return [key, sample ?? ''];
    }),
  );
}

// Input rows are typed as strings, but the preview can carry numbers, booleans or nested values.
function toCellText(value: unknown): string {
  if (value === undefined || value === null) {
    return '';
  }
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return value.toString();
  }
  return JSON.stringify(value) ?? '';
}

export function truncateSample(value: string, maxLength: number): string {
  return value.length > maxLength ? `${value.slice(0, maxLength - 1)}…` : value;
}
